import type {
  GetCutoffDatesResponse,
  GetCutoffDatesResponseItem,
} from '@omnipresentgroup/types';

import { DEFAULT_LEGAL_ENTITY } from '../legalEntities';

export const DEFAULT_CUTOFF_DATES_ITEM: GetCutoffDatesResponseItem = {
  cutoffDates: ['2025-06-15T23:59:00.000Z'],
  legalEntity: {
    id: DEFAULT_LEGAL_ENTITY.id,
    lspId: DEFAULT_LEGAL_ENTITY.lspId,
    countryCode: DEFAULT_LEGAL_ENTITY.countryCode,
    name: DEFAULT_LEGAL_ENTITY.name,
  },
};

export const GET_CUTOFF_DATES_RESPONSE: GetCutoffDatesResponse = [
  DEFAULT_CUTOFF_DATES_ITEM,
];
